export const SHARED_PROMPT_HEADER_FOR_HERO_SECTION = 'sections-minimals-hero-id'
export const SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING = 'sections-special-engineering-id'
